<template>
    <span v-if="readOnly">
        {{candidate.format("HH:mm")}}
    </span>
    <div v-else>
        <input type="text" :class="{'text-danger':invalidState}"
               :placeholder="placeholder || format"
               v-model="candidate"
               @keyup="onKeyUp" @blur="onBlur" maxlength="5" />
    </div>

</template>

<script>
    import moment from 'moment'
    export default {
        name: "TimeInput",
        props: {
            initialValue: Object,
            minValue: Object,
            maxValue: Object,
            readOnly: { type: Boolean, default: false },
            format: { type: String, required: true, default: 'HH:mm' },
            placeholder: { type: String, default: 'HH:mm' },
        },
        watch: {
            initialValue: function (to, from) {
                this.candidate = (this.initialValue || this.minToMoment(0)).format('HH:mm');
                this.isValidTime(this.candidate);
            }
        },
        data() {
            return {
                candidate: (this.initialValue || this.minToMoment(0)).format('HH:mm'),
                validValue: null,
                invalidState: false,
                parsed: null
            }
        },
        methods: {
            isValidTime(data) {
                var reg = /(0[0-9]|1[0-9]|2[0-3]|[0-9]):([0-5][0-9])/;
                if (!reg.test(data)) {
                    this.invalidState = true;
                    return false;
                }
                else {
                    var match = reg.exec(data);
                    var minutes = parseInt(match[1]) * 60 + parseInt(match[2]);
                    this.parsed = this.minToMoment(minutes);

                    if (this.minValue != null)
                    {
                        this.minValue > this.parsed;
                        this.candidate = this.minValue;
                    }
                    if (this.maxValue != null) {
                        this.maxValue < this.parsed;
                        this.candidate = this.maxValue;
                    }
                    this.invalidState = false;
                    console.log("Match", match);
                }

                return true;
            },
            onBlur(e) {
                var isValid = this.isValidTime(this.candidate);
                console.log("Is Valid:", isValid)
                if (!isValid) {
                    this.candidate = (this.initialValue || this.minToMoment(0)).format('HH:mm');
                }
                else {
                    this.$emit("onValueChanged", this.parsed);
                }
            },
            onKeyUp(e) {
                console.log(e, this.candidate);
            },
        }
    }
</script>

<style scoped>
</style>
